import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";
import { MetricFilter, METRIC_PRESETS, BASE_DATE_RANGE_PRESETS, PIVOT_DATE_RANGE_PRESETS } from "../common/filters";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Rep Type",
    type: FILTER_TYPES.Switch,
    defaultValue: 'client_rep_id',
    fields: "group_by_type",
    options: [
      { label: 'Client Rep', value: 'client_rep_id' },
      { label: 'Order Rep', value: 'order_rep_id' },
    ],
    flexBasis: 250,
    containerStyle: {
      minWidth: '250px',
    },
  },
  {
    label: "Range 1",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_1", "start_date_range_1", "end_date_range_1"],
    defaultValue: ["", "", ""],
    presets: BASE_DATE_RANGE_PRESETS,
  },
  {
    label: "Range 2",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_2", "start_date_range_2", "end_date_range_2"],
    defaultValue: ["", "", ""],
    dependsOn: { filterFields: ["category_date_range_1"] },
    presets: BASE_DATE_RANGE_PRESETS,
    presetPivots: PIVOT_DATE_RANGE_PRESETS,
  },
  {
    label: "Metric",
    fields: "metric_type",
    type: FILTER_TYPES.Switch,
    defaultValue: MetricFilter.Total,
    options: METRIC_PRESETS,
    flexBasis: 400,
  },
];
